import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing an users icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <UsersIcon width={12} />
 */
const UsersIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path d="M24,24A10,10,0,1,0,14,14,10.012,10.012,0,0,0,24,24Z" />
        <path
            d={`M44,38.3V38l0-2.92c0-4.646-2.163-7.676-4.329-8.763A31.4,
            31.4,0,0,0,34.408,24,16.629,16.629,0,0,1,13.52,24a30.693,30.693,
            0,0,0-5.243,2.313C5.9,27.325,4,30.43,4,35.076V40a2,2,0,0,0,2,
            2H42a2,2,0,0,0,2-2V38.3ZM27.979,32H36v4H27.979Z`}
        />
    </SvgIcon>
)

UsersIcon.defaultProps = defaultProps

export { UsersIcon }
